import { ReactElement } from 'react';

import SummaryInformation from 'src/pages/AddMerchantPage/steps/SummaryInformation';
import AddServiceStep from 'src/pages/AddServicePage/steps/addService';
export type Step = {
    label: string;
    completed: boolean;
    accessor: string;
    form: ReactElement;
};

export const ADD_SERVICE_STEPS: Step[] = [
    {
        label: 'Service Order Details',
        accessor: 'serviceId',
        completed: false,
        form: <AddServiceStep />,
    },
    {
        label: 'Summary',
        accessor: 'summary',
        completed: false,
        form: <SummaryInformation isAddService />,
    },
];
